import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import PostLoginGetApi from "../Api/PostLoginGetApi";
import {Dropdown} from "primereact/dropdown";
import {FloatLabel} from "primereact/floatlabel";
import Tailwind from "primereact/passthrough/tailwind";
import {PrimeReactProvider} from "primereact/api";

function SpecAttributes({selectedGlobalCategory, specValue, setSpecValue}) {
    const [specAttributeList, setSpecAttributesList] = useState([]);


    // Fetch Spec Attribute Based on Global Category Selected
    useEffect(() => {
        if (selectedGlobalCategory) {
            PostLoginGetApi("get-spec-attribute-values/" + selectedGlobalCategory).then((responseJSON) => {
                let response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);

                    if (responseData["code"] === 200 && responseData["data"] !== undefined) {
                        setSpecAttributesList(responseData["data"]["spec_attributes_items"]);
                    }

                    toast.error(response["messages"]?.toString() ?? response["message"]?.toString());
                }

            }).catch((err) => {
                console.log(err);
            });
        }

    }, [selectedGlobalCategory]);


    return <>
            {specAttributeList.map((option, index) => {
                let possibleOptions = option.get_possible_values.map((item, index) => {
                    return {code: item.id, name: item.value};
                });
                possibleOptions.push({code: null, name: 'Other'})

                return (
                    <div className="card flex justify-content-center mt-5 p-2">
                        <FloatLabel className="w-full md:w-14rem p-1">
                            <Dropdown
                                inputId={index}
                                value={specValue[option.id]}
                                onChange={(e) => setSpecValue(prevState => ({...prevState, [option.id]: e.target.value}))}
                                focusOnHover={true}
                                options={possibleOptions}
                                optionLabel='name'
                                className="!w-full border border-1  p-0"
                                filter
                                showClear
                            />
                            <label htmlFor={index}>{option.attribute_name}</label>
                        </FloatLabel>
                    </div>
                )
            })}

            <style jsx="true">{`
                .p-dropdown-filter-container {
                    border-radius: 8px !important;
                }
            `}</style>
    </>
}

export default SpecAttributes;
